import { render } from "./SignUp.vue?vue&type=template&id=6bed3be7&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "../../assets/css/Main.css?vue&type=style&index=0&id=6bed3be7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\CloudSecOffice\\Documents\\Gravitas\\microservice\\Frontend\\enterprise_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bed3be7"]])

export default __exports__